<script setup lang="ts">
import { i18n } from '@/i18n.js';

const tips = [
  i18n.global.t('features.tips.add_column'),
  i18n.global.t('features.tips.aerial_photo'),
  i18n.global.t('features.tips.diagnostics'),
  i18n.global.t('features.tips.filter_preset'),
  i18n.global.t('features.tips.locale_switch'),
  i18n.global.t('features.tips.map_filter'),
  i18n.global.t('features.tips.notes_files'),
  i18n.global.t('features.tips.search_everywhere'),
  i18n.global.t('features.tips.sundata_support'),
  i18n.global.t('features.tips.whats_new'),
];

const randomIndex = Math.floor(Math.random() * tips.length);
const randomTip = tips[randomIndex];
</script>

<template>
  <div class="mx-4 mt-1">
    <font-awesome-icon icon="lightbulb" class="text-xs text-slate-400"/>
    <span class="small-text text-slate-500"> Tip: {{ randomTip }} </span>
  </div>
</template>

<style scoped>

</style>